import { includes } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { EMPTY_VALUES } from 'constants/general';
import { contactAgeIds } from 'features/views/semaphore/constants';
import { cleanse } from 'utils';
import { joinString } from 'utils/string';

export const searchSemaphoreListBodyFactory = (formData, userName) => {
	const threatObj = generateThreatObject(formData?.impendingState);

	return cleanse({
		birthDateFrom: formData.birthYearFrom ? Number(formData?.birthYearFrom) : EMPTY_VALUES.STRING,
		birthDateTo: formData.birthYearTo ? Number(formData?.birthYearTo) : EMPTY_VALUES.STRING,
		birthNumber: formData?.personIn,
		businessIn: formData?.businessIn,
		feedbackId: formData.feedback ? Number(formData?.feedback) : EMPTY_VALUES.STRING,
		firstName: formData?.firstName,
		lastCommunicationAgeId: formData.semaphore ? Number(formData?.semaphore) : EMPTY_VALUES.STRING,
		municipality: formData?.municipality,
		notInsuredProductDomainIds: !isNilOrEmpty(formData.notInsuredProductDomain)
			? formData?.notInsuredProductDomain.map((id) => Number(id))
			: EMPTY_VALUES.ARRAY,
		policyProductDomainIds: !isNilOrEmpty(formData.productDomain)
			? formData?.productDomain.map((id) => Number(id))
			: EMPTY_VALUES.ARRAY,
		surname: formData?.surname,
		threat: threatObj,
		userName,
		zipCode: formData?.zipCode,
	});
};

export const generateThreatObject = (impendingStateValue) => {
	let month;
	let lastCommunicationAgeId;

	switch (Number(impendingStateValue)) {
		case 10:
			lastCommunicationAgeId = 23;
			month = 1;
			break;
		case 20:
			lastCommunicationAgeId = 23;
			month = 2;
			break;
		case 30:
			lastCommunicationAgeId = 23;
			month = 3;
			break;
		case 40:
			lastCommunicationAgeId = 26;
			month = 1;
			break;
		case 50:
			lastCommunicationAgeId = 26;
			month = 2;
			break;
		case 60:
			lastCommunicationAgeId = 26;
			month = 3;
			break;
		case 70:
			lastCommunicationAgeId = 29;
			month = 1;
			break;
		case 80:
			lastCommunicationAgeId = 29;
			month = 2;
			break;
		case 90:
			lastCommunicationAgeId = 29;
			month = 3;
			break;
	}

	return {
		lastCommunicationAgeId,
		month,
	};
};

export const chooseColorBasedOnId = (id) => {
	let color;
	switch (Number(id)) {
		case contactAgeIds.oneToTwoYears:
			color = '#27ae60';
			break;
		case contactAgeIds.threeToFourYears:
			color = '#f57f17';
			break;

		case contactAgeIds.fiveToSixYears:
			color = '#c21b17';
			break;

		case contactAgeIds.sevenAndLaterYears:
		case contactAgeIds.semaphorePO:
			color = '#6f7072';
			break;
	}

	return color;
};

export const generateFromAndToColorForWalkingIcon = (id) => {
	let obj;
	if (includes(Number(id), [10, 20, 30])) {
		obj = {
			fromColor: '#27ae60',
			toColor: '#f57f17',
		};
	}

	if (includes(Number(id), [40, 50, 60])) {
		obj = {
			fromColor: '#f57f17',
			toColor: '#c21b17',
		};
	}

	if (includes(Number(id), [70, 80, 90])) {
		obj = {
			fromColor: '#c21b17',
			toColor: '#6f7072',
		};
	}

	return obj;
};

export const generateClickTableTransitionValue = (id) => {
	let transition;
	if (includes(Number(id), [10, 20, 30])) {
		transition = 'Přesun zelená > oranžová';
	}

	if (includes(Number(id), [40, 50, 60])) {
		transition = 'Přesun oranžová > červená';
	}

	if (includes(Number(id), [70, 80, 90])) {
		transition = 'Přesun červená > šedá';
	}

	return transition;
};

export const generateClickTableTimeValue = (id) => {
	let time;
	if (includes(Number(id), [10, 40, 70])) {
		time = 'Do 1 Měsíce';
	}

	if (includes(Number(id), [20, 50, 80])) {
		time = 'Do 2 Měsíců';
	}

	if (includes(Number(id), [30, 60, 90])) {
		time = 'Do 3 Měsíců';
	}

	return time;
};

export const generateClickTableValuePair = (id) => {
	const time = generateClickTableTimeValue(id);
	const transition = generateClickTableTransitionValue(id);
	return joinString(',', [time, transition]);
};
